<template>
  <div  id="app" class="h-100" v-on:contextmenu.prevent>
    <!-- <router-view/> -->
      <!-- <div class="demo-spin-col" v-if="this.$store.getters.loader">
          <Spin fix>
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          </Spin>
      </div> -->
      <router-view :key="this.$route.fullPath"/>
  </div>
</template>

<script>
import { $themeColors, $themeBreakpoints, $themeConfig } from '../themeConfig'
import { useWindowSize, useCssVar } from '@vueuse/core'
import { watch } from '@vue/composition-api'
import useAppConfig from './@core/app-config/useAppConfig'
import store from './store/index'

export default {
  name: 'App',
  computed: {
    isLogin: function () {
      return this.$store.getters.isLogin;
    },
    member: function () {
      return this.$store.getters.member;
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']
    
    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }
    
    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }
    
    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })
  },
  mounted() {
    this.addScriptTag()
    let { ethereum } = window;
    if(ethereum && ethereum.providerMap) {
      ethereum.providerMap.forEach(element => {
        if(element.isMetaMask) {
          ethereum = element
        }
      });
    }

    if (!ethereum) {
      // Nothing to do here... no ethereum provider found
      return;
    }

    ethereum.on('accountsChanged', async function () {
      await store.dispatch("checkIfConnected")
    })

    ethereum.on('chainChanged', async function () {
      await store.dispatch("checkNetwork")
    })

  },
  methods: {
    addScriptTag() {
        this.$http.get(this.host + '/ico/get-site-header-footer-setting')
          .then((response) => {
              var resp = response.body;
              if (resp.code == 0) {
                resp.data.map(item => {
                  if(item.field === 'site_header_code') {
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(item.value, 'text/html');
                    htmlDoc.head.childNodes.forEach(c => {
                        document.getElementsByTagName('head')[0].appendChild(c);
                    });
                  }
                  if(item.field === 'site_footer_code') {
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(item.value, 'text/html');
                    htmlDoc.head.childNodes.forEach(c => {
                        document.getElementsByTagName('body')[0].appendChild(c);
                    });
                  }
                })
              } else {
                  this.$toast.error(resp.message);
              }
          });
      }
  }
}
</script>





// WEBPACK FOOTER //
// src/App.vue